import React from 'react';
import Traductor from '../Traductor';
import { withCookies } from 'react-cookie';
import '../../css/components/shared/vehicleCard/VehicleCard.css';
import CountDown from '../CountDown';
import Tag from '../bronson/Tag';

function VehicledealerReceptorTags({
    vehicle,
    floating = false,
    vehicleStatus,
    changeVehicleStatus,
    viewType,
    serverTime,
}) {
    const t = new Traductor();

    const printCardTagsList = () => {
        let tagsList = [];
        let textSkeleton = 'Loading...';
        let classList =
            floating || viewType === 'detail' ? 'absolute-list' : '';
        let isCornerTags = false;
        if (
            viewType === 'detail' ||
            (viewType !== 'detail' && window.innerWidth < 720)
        )
            isCornerTags = true;

        if (vehicle.EndDate) {
            if (vehicleStatus === 2) {
                tagsList.push(
                    <li key={`${vehicle.Id}-finalized-term-tag`}>
                        <Tag
                            classes={['warning']}
                            text={t.getTraduction('TermFinaliced')}
                            type={isCornerTags ? 'corner' : ''}
                        ></Tag>
                    </li>
                );
            } else {
                tagsList.push(
                    <li key={`${vehicle.Id}-countdown-tag-key`}>
                        <Tag
                            text={
                                <CountDown
                                    dateTime={vehicle.EndDate}
                                    isFinishedParent={changeVehicleStatus}
                                    serverTime={serverTime}
                                ></CountDown>
                            }
                            type={isCornerTags ? 'corner' : ''}
                        ></Tag>
                    </li>
                );
            }
        }

        if (vehicle.Product) {
            let classTypeOperation = '';
            let textTypeOperation = vehicle.Product.CuadroMandoDescription;
            switch (vehicle.Product.CuadroMandoId) {
                case '132':
                    classTypeOperation = 'retail';
                    break;
                case '133':
                    classTypeOperation = 'lineal';
                    break;
                case '134':
                    classTypeOperation = 'cpc';
                    break;
                case '135':
                    classTypeOperation = 'fleet';
                    break;
                case '166':
                    classTypeOperation = 'cpc';
                    break;
                default:
                    break;
            }
            if (classTypeOperation !== '') {
                tagsList.push(
                    <li key={`${vehicle.Id}-${classTypeOperation}`}>
                        <Tag
                            classes={[classTypeOperation]}
                            text={textTypeOperation}
                            type={isCornerTags ? 'corner' : ''}
                        ></Tag>
                    </li>
                );
            }
        } else if (vehicle.skeleton) {
            tagsList.push(
                <li key={`key-skeleton-tag`}>
                    <Tag classes={['default']} text={textSkeleton}></Tag>
                </li>
            );
        }

        if (vehicle.ImporteIncentivoRecompraAC && vehicle.ImporteIncentivoRecompraAC > 1) {
            tagsList.push(
                <li key={`${vehicle.Id}-incentivo-tag`}>
                    <Tag
                        classes={['success']}
                        text={t.getTraduction('IncentiveAvailable')}
                        type={isCornerTags ? 'corner' : ''}
                    ></Tag>
                </li>
            );
        }

        return (
            <ul className={'c-tag-list u-mb-small ' + classList}>{tagsList}</ul>
        );
    };

    return printCardTagsList();
}

export default withCookies(VehicledealerReceptorTags);
